/**
 * CLEARSTEM Active Breakout Routine A/B Price Test
 *
 * Convert.com variation sets: window.__csActiveBreakoutPriceTest = true
 * Then dispatches: document.dispatchEvent(new Event('csActiveBreakoutPriceTestActivated'))
 */
(function () {
    'use strict';

    var ORIGINAL = {
        productId: '8675813130465',
        variantId: '45589666857185',
        handle: 'active-breakout-routine',
        price: 18400,
        subscriptionPrice: 15640
    };

    var TEST = {
        productId: '9482342203617',
        variantId: '48379347468513',
        handle: 'active-breakout-routine-2',
        price: 16500
    };

    var SELLING_PLAN_MAP = {
        '4834132193': '6200361185',
        '4834001121': '6200393953',
        '4834033889': '6200426721'
    };

    var activated = false;
    var testProductDataCache = null;

    function formatMoney(cents) {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
        }).format(cents / 100);
    }

    function formatMoneyShort(cents) {
        var d = cents / 100;
        return d % 1 === 0 ? '$' + d.toFixed(0) : '$' + d.toFixed(2);
    }

    function isOriginalProductId(val) {
        return String(val) === ORIGINAL.productId;
    }

    function isOriginalVariantId(val) {
        return String(val) === ORIGINAL.variantId;
    }

    function isOriginalPDP() {
        var path = window.location.pathname;
        return path.indexOf('/products/' + ORIGINAL.handle) !== -1 &&
            path.indexOf('/products/' + TEST.handle) === -1;
    }

    function isActiveBreakoutSelectionContext() {
        if (isOriginalPDP()) return true;

        var selectedProductInput = document.querySelector('input[name="tied_product_selection"]:checked');
        if (selectedProductInput) {
            return isOriginalProductId(selectedProductInput.value) ||
                isOriginalProductId(selectedProductInput.getAttribute('data-product-id')) ||
                selectedProductInput.getAttribute('data-product-handle') === ORIGINAL.handle;
        }

        return !!document.querySelector(
            '.purchase-options__add-button[data-product-id="' + ORIGINAL.productId + '"],' +
            '.purchase-options__add-button[data-variant-id="' + ORIGINAL.variantId + '"],' +
            'form[data-product-form] input[name="id"][value="' + ORIGINAL.variantId + '"]'
        );
    }

    function isAcneFunnelPage() {
        return window.location.pathname.indexOf('/pages/acne-funnel') !== -1;
    }

    function isSubscriptionSelected() {
        var subInput = document.querySelector('input[name="purchase_type"][value="subscribe"]');
        if (subInput && subInput.checked) return true;

        var radios = document.querySelectorAll('.purchase-options__radio-option');
        for (var i = 0; i < radios.length; i++) {
            var input = radios[i].querySelector('input[value="subscribe"]');
            if (input && radios[i].classList.contains('purchase-options__radio-option--selected')) {
                return true;
            }
        }
        return false;
    }

    function getTestProductData() {
        if (testProductDataCache) {
            return Promise.resolve(testProductDataCache);
        }
        if (window.__csActiveBreakoutTestProductData) {
            testProductDataCache = window.__csActiveBreakoutTestProductData;
            return Promise.resolve(testProductDataCache);
        }
        return fetch('/products/' + TEST.handle + '.js')
            .then(function (r) { return r.json(); })
            .then(function (data) {
                testProductDataCache = data;
                window.__csActiveBreakoutTestProductData = data;
                return data;
            });
    }

    function getTestPrice(testData) {
        if (testData && testData.variants && testData.variants.length) {
            var matchingVariant = testData.variants.find(function (variant) {
                return String(variant.id) === TEST.variantId;
            });
            if (matchingVariant) return matchingVariant.price;
        }
        return testData && typeof testData.price === 'number' ? testData.price : TEST.price;
    }

    function getTestVariant(testData) {
        if (!testData || !testData.variants || !testData.variants.length) return null;
        return testData.variants.find(function (variant) {
            return String(variant.id) === TEST.variantId;
        }) || testData.variants[0];
    }

    function getSelectedTestSellingPlanId() {
        var atcBtn = document.querySelector('.purchase-options__add-button');
        var selectedPlan = atcBtn ? atcBtn.getAttribute('data-selling-plan-id') : '';
        if (selectedPlan && SELLING_PLAN_MAP[selectedPlan]) {
            selectedPlan = SELLING_PLAN_MAP[selectedPlan];
        }
        if (selectedPlan) return String(selectedPlan);

        var sellingPlanSelect = document.getElementById('selling_plan_select');
        if (sellingPlanSelect && sellingPlanSelect.value) {
            return SELLING_PLAN_MAP[sellingPlanSelect.value] || String(sellingPlanSelect.value);
        }

        var frequencySelect = document.getElementById('subscription-frequency');
        if (frequencySelect && frequencySelect.value) {
            return SELLING_PLAN_MAP[frequencySelect.value] || String(frequencySelect.value);
        }

        return '';
    }

    function getTestSubscriptionPrice(testData) {
        var data = testData || testProductDataCache || window.__csActiveBreakoutTestProductData;
        var variant = getTestVariant(data);
        var allocations = variant && variant.selling_plan_allocations;
        if (allocations && allocations.length) {
            var selectedPlan = getSelectedTestSellingPlanId();
            var matchingAllocation = selectedPlan ? allocations.find(function (allocation) {
                return String(allocation.selling_plan_id) === selectedPlan;
            }) : null;
            var allocation = matchingAllocation || allocations[0];
            if (typeof allocation.price === 'number') return allocation.price;
            if (typeof allocation.per_delivery_price === 'number') return allocation.per_delivery_price;
        }

        return ORIGINAL.subscriptionPrice;
    }

    function swapElements(root, testData) {
        if (!root) return;

        var testPrice = getTestPrice(testData);
        var priceText = testPrice ? formatMoney(testPrice) : '';
        var shortPriceText = testPrice ? formatMoneyShort(testPrice) : '';

        var scopedButtons = root.querySelectorAll(
            'button[data-product-id="' + ORIGINAL.productId + '"],' +
            'button[data-variant-id="' + ORIGINAL.variantId + '"],' +
            '[data-product-id="' + ORIGINAL.productId + '"].add-to-cart-button,' +
            '.routine-buybox__button.add-to-cart-button,' +
            '.cs-routine-product-details__add-routine-button.add-to-cart-button'
        );

        scopedButtons.forEach(function (btn) {
            var hasOriginalProduct = isOriginalProductId(btn.getAttribute('data-product-id'));
            var hasOriginalVariant = isOriginalVariantId(btn.getAttribute('data-variant-id'));
            var isRoutineButton = btn.classList.contains('routine-buybox__button') ||
                btn.classList.contains('cs-routine-product-details__add-routine-button');
            var isProductCardButton = btn.closest('.cs-plp-product-card__product') ||
                btn.closest('.cs-product-card__product');

            if (!hasOriginalProduct && !hasOriginalVariant) return;

            if (hasOriginalProduct) {
                btn.setAttribute('data-product-id', TEST.productId);
            }
            if (hasOriginalVariant) {
                btn.setAttribute('data-variant-id', TEST.variantId);
            }
            var sp = btn.getAttribute('data-selling-plan-id');
            if (sp && SELLING_PLAN_MAP[sp]) {
                btn.setAttribute('data-selling-plan-id', SELLING_PLAN_MAP[sp]);
            }

            var priceSpan = btn.querySelector('.button-price');
            if (priceSpan && priceText) {
                priceSpan.textContent = (isRoutineButton || isProductCardButton) ? shortPriceText : priceText;
            }
        });

        if (isAcneFunnelPage() && shortPriceText) {
            var funnelButtons = root.querySelectorAll('.cs-routine-product-details__add-routine-button.add-to-cart-button');
            funnelButtons.forEach(function (btn) {
                var priceSpan = btn.querySelector('.button-price');
                if (priceSpan) {
                    priceSpan.textContent = shortPriceText;
                }
            });
        }

        var hiddenInputs = root.querySelectorAll('input[name="id"][value="' + ORIGINAL.variantId + '"]');
        hiddenInputs.forEach(function (input) {
            input.value = TEST.variantId;
        });

        var recDivs = root.querySelectorAll(
            '.product-recommendation[data-product-id="' + ORIGINAL.productId + '"],' +
            '[data-product-id="' + ORIGINAL.productId + '"][data-product-price]'
        );
        recDivs.forEach(function (div) {
            div.setAttribute('data-product-id', TEST.productId);
            if (div.hasAttribute('data-product-variant-id')) {
                div.setAttribute('data-product-variant-id', TEST.variantId);
            }
            if (div.hasAttribute('data-product-price') && priceText) {
                div.setAttribute('data-product-price', priceText);
            }
        });
    }

    function swapPDP(testData) {
        if (!isOriginalPDP()) return;

        if (typeof window.primaryProductData !== 'undefined') {
            window.primaryProductData.id = testData.id;
            window.primaryProductData.handle = testData.handle;
            window.primaryProductData.variants = testData.variants;
            window.primaryProductData.selling_plan_groups = testData.selling_plan_groups;
        }

        updateProductForms();
        updatePDPPrices(testData);
        updateSellingPlanSelects();
        patchPurchaseOptionsInteractions();
        swapElements(document, testData);
    }

    function updateProductForms() {
        if (!isActiveBreakoutSelectionContext()) return;

        var forms = document.querySelectorAll('form[data-product-form]');
        forms.forEach(function (form) {
            var idInput = form.querySelector('input[name="id"]');
            if (idInput && isOriginalVariantId(idInput.value)) {
                idInput.value = TEST.variantId;
            }
        });
    }

    function updatePDPPrices(testData) {
        if (!isActiveBreakoutSelectionContext()) return;

        var testSubscriptionPrice = getTestSubscriptionPrice(testData);

        var otPrice = document.querySelector('[data-onetime-price]');
        if (otPrice) {
            otPrice.textContent = formatMoney(TEST.price);
        }

        var otRadioPrice = document.querySelector('.purchase-options__radio-price[data-onetime-price]');
        if (otRadioPrice) {
            otRadioPrice.textContent = formatMoney(TEST.price);
        }

        var subPriceEls = document.querySelectorAll('[data-subscription-price]');
        subPriceEls.forEach(function (el) {
            el.textContent = formatMoney(testSubscriptionPrice);
        });

        var subscriptionLabels = document.querySelectorAll('[data-subscription-label]');
        subscriptionLabels.forEach(function (label) {
            label.textContent = label.getAttribute('data-subscription-label-base') || 'Subscribe + Save';
        });

        var atcButtons = document.querySelectorAll('.purchase-options__add-button, .sticky-mobile-atc__add-button');
        atcButtons.forEach(function (btn) {
            if (isOriginalProductId(btn.getAttribute('data-product-id'))) {
                btn.setAttribute('data-product-id', TEST.productId);
            }
            if (isOriginalVariantId(btn.getAttribute('data-variant-id'))) {
                btn.setAttribute('data-variant-id', TEST.variantId);
            }
            if (btn.classList.contains('purchase-options__add-button') && !btn.getAttribute('data-product-id')) {
                btn.setAttribute('data-product-id', TEST.productId);
            }

            var sp = btn.getAttribute('data-selling-plan-id');
            if (sp && SELLING_PLAN_MAP[sp]) {
                btn.setAttribute('data-selling-plan-id', SELLING_PLAN_MAP[sp]);
            }

            var btnPrice = btn.querySelector('.button-price');
            if (btnPrice) {
                btnPrice.textContent = isSubscriptionSelected() ? formatMoney(testSubscriptionPrice) : formatMoney(TEST.price);
            }
        });

        var comparePrices = document.querySelectorAll('.purchase-options__radio-compare-price, [data-button-compare-price]');
        comparePrices.forEach(function (el) {
            if (el.textContent.trim() === formatMoney(ORIGINAL.price) || el.textContent.trim() === formatMoneyShort(ORIGINAL.price)) {
                el.textContent = formatMoney(TEST.price);
            }
        });

        var hiddenPrice = document.querySelector('.product-details__price .price-item--regular');
        if (hiddenPrice) {
            hiddenPrice.textContent = formatMoney(TEST.price);
        }

        var installTexts = document.querySelectorAll('.purchase-options__installments, .afterpay-paragraph');
        installTexts.forEach(function (el) {
            var origInstallment = formatMoney(Math.round(ORIGINAL.price / 4));
            var testInstallment = formatMoney(Math.round(TEST.price / 4));
            if (el.innerHTML.indexOf(origInstallment) !== -1) {
                el.innerHTML = el.innerHTML.replace(origInstallment, testInstallment);
            }
        });
    }

    function updateSellingPlanSelects() {
        if (!isActiveBreakoutSelectionContext()) return;

        var selects = document.querySelectorAll('#selling_plan_select, #subscription-frequency, #sticky-subscription-frequency');
        selects.forEach(function (select) {
            var opts = select.querySelectorAll('option');
            opts.forEach(function (opt) {
                if (SELLING_PLAN_MAP[opt.value]) {
                    opt.value = SELLING_PLAN_MAP[opt.value];
                }
            });
        });

        var choicesContainers = document.querySelectorAll('.purchase-options__frequency-select, .sticky-mobile-atc__frequency-select');
        choicesContainers.forEach(function (container) {
            var choices = container._choices || container.choicesInstance;
            if (!choices) return;
            try {
                choices._store.choices.forEach(function (item) {
                    if (SELLING_PLAN_MAP[item.value]) {
                        item.value = SELLING_PLAN_MAP[item.value];
                    }
                });
            } catch (e) {
                // Choices.js internals may vary.
            }
        });

        if (window.choicesInstances) {
            ['main', 'sticky'].forEach(function (key) {
                var choices = window.choicesInstances[key];
                if (!choices || !choices._store) return;
                try {
                    choices._store.choices.forEach(function (item) {
                        if (SELLING_PLAN_MAP[item.value]) {
                            item.value = SELLING_PLAN_MAP[item.value];
                        }
                    });
                } catch (e) {
                    // Choices.js internals may vary.
                }
            });
        }
    }

    function correctPDPAfterInteraction() {
        function correct() {
            updateProductForms();
            updateSellingPlanSelects();
            updatePDPPrices();
        }

        correct();
        requestAnimationFrame(correct);
        setTimeout(correct, 0);
        setTimeout(correct, 50);
        setTimeout(correct, 150);
    }

    function patchPurchaseOptionsInteractions() {
        if (window.__csActiveBreakoutPdpInteractionsPatched) return;
        window.__csActiveBreakoutPdpInteractionsPatched = true;

        document.querySelectorAll('input[name="tied_product_selection"]').forEach(function (radio) {
            radio.addEventListener('change', correctPDPAfterInteraction);
            radio.addEventListener('click', correctPDPAfterInteraction);
        });

        document.querySelectorAll('.purchase-options__radio-option').forEach(function (radio) {
            radio.addEventListener('click', correctPDPAfterInteraction);
        });

        document.querySelectorAll('#subscription-frequency, #sticky-subscription-frequency').forEach(function (select) {
            select.addEventListener('change', correctPDPAfterInteraction);
        });

        document.querySelectorAll('.choices').forEach(function (choicesContainer) {
            choicesContainer.addEventListener('choice', function () {
                setTimeout(correctPDPAfterInteraction, 50);
            });
        });

        document.addEventListener('subscription:changed', correctPDPAfterInteraction);
        document.addEventListener('variant:change', correctPDPAfterInteraction);
    }

    function applySwaps() {
        getTestProductData().then(function (testData) {
            swapElements(document, testData);
            swapPDP(testData);
            updatePDPPrices(testData);
        }).catch(function (err) {
            console.error('[Active Breakout A/B Test] Failed to load test product data:', err);
        });
    }

    function setupObserver() {
        var observer = new MutationObserver(function (mutations) {
            var needsSwap = false;
            for (var i = 0; i < mutations.length; i++) {
                var added = mutations[i].addedNodes;
                for (var j = 0; j < added.length; j++) {
                    var node = added[j];
                    if (node.nodeType !== 1) continue;
                    if (node.querySelector) {
                        if (node.querySelector('[data-product-id="' + ORIGINAL.productId + '"]') ||
                            node.querySelector('[data-variant-id="' + ORIGINAL.variantId + '"]') ||
                            node.querySelector('input[name="id"][value="' + ORIGINAL.variantId + '"]') ||
                            node.querySelector('.routine-buybox__button.add-to-cart-button') ||
                            node.querySelector('.cs-routine-product-details__add-routine-button.add-to-cart-button')) {
                            needsSwap = true;
                            break;
                        }
                    }
                    if (node.getAttribute) {
                        if (isOriginalProductId(node.getAttribute('data-product-id')) ||
                            isOriginalVariantId(node.getAttribute('data-variant-id'))) {
                            needsSwap = true;
                            break;
                        }
                    }
                }
                if (needsSwap) break;
            }

            if (needsSwap) {
                applySwaps();
            }
        });

        observer.observe(document.body || document.documentElement, {
            childList: true,
            subtree: true
        });
    }

    function patchFetch() {
        var origFetch = window.fetch;
        window.fetch = function () {
            var url = arguments[0];
            if (typeof url === 'string' && url.indexOf('product-recommendations') !== -1) {
                return origFetch.apply(this, arguments).then(function (response) {
                    setTimeout(applySwaps, 200);
                    return response;
                });
            }
            return origFetch.apply(this, arguments);
        };
    }

    function patchCartOpen() {
        document.addEventListener('click', function (e) {
            var trigger = e.target.closest('[data-cart-trigger]') ||
                e.target.closest('.header__icon--cart') ||
                e.target.closest('#cart-icon-bubble') ||
                e.target.closest('.cart-count-bubble');
            if (trigger) {
                setTimeout(applySwaps, 500);
                setTimeout(applySwaps, 1500);
            }
        });
    }

    function runTest() {
        if (activated) return;
        activated = true;

        updateProductForms();
        updateSellingPlanSelects();
        updatePDPPrices();
        patchPurchaseOptionsInteractions();
        applySwaps();

        if (document.body) {
            setupObserver();
        } else {
            document.addEventListener('DOMContentLoaded', setupObserver);
        }

        patchFetch();
        patchCartOpen();

        if (document.readyState !== 'complete') {
            window.addEventListener('load', applySwaps);
        }

        setTimeout(applySwaps, 1000);
        setTimeout(applySwaps, 3000);
    }

    function hasQueryTrigger() {
        return window.location.search.indexOf('cs_active_breakout_price_test=true') !== -1;
    }

    window.__csRunActiveBreakoutPriceTest = runTest;

    if (window.__csActiveBreakoutPriceTest || hasQueryTrigger()) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', runTest);
        } else {
            runTest();
        }
    }

    document.addEventListener('csActiveBreakoutPriceTestActivated', function () {
        if (!activated) {
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', runTest);
            } else {
                runTest();
            }
        }
    });
})();
